import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-reset\"><defs><style type=\"text/css\"></style></defs><path d=\"M694.692654 984.33983L565.989005 850.006997c167.852074-22.26087 301.929035-162.222889 301.929036-330.074963 0-162.222889-123.074463-301.929035-285.297351-330.074963l-117.445278-117.445277h50.406797c257.151424 0 464.151924 201.371314 464.151924 447.52024 0 167.852074-100.557721 318.816592-240.51974 391.484258v111.816092l-44.521739-38.892554z m-123.074463-22.260869c-16.887556 0-39.148426 5.629185-61.409295 5.629185-257.151424 0-464.151924-201.371314-464.151924-447.52024 0-167.852074 100.557721-318.816592 240.51974-391.484258V0L471.06047 184.73963c-173.481259 16.887556-307.558221 162.222889-307.558221 335.448276 0 167.852074 128.703648 307.558221 296.29985 330.074963l111.816092 111.816092z m0 0\" fill=\"#444444\" p-id=\"1140\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/reset.svg
// module id = kaIC
// module chunks = 197